// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__20B_j","selects":"Documents_selects__2nV6-"};